<template>
	<div class="surveillance flex">
		<div class="flex flex-direction operaBoxLeft">
        	<boxTitle style="margin-top: 10px" :title="'实时告警'" :subtitle="'Real-time Alarm'"></boxTitle>
			<div style="margin-top: 10px" class="alarm-flex">
				<RealTimeAlarm></RealTimeAlarm>
				<EquipmentFailure></EquipmentFailure>
			</div>
			<videoBox />
		</div>
		<div class="operaBoxRight">
        	<boxTitle :title="'告警分析'" :subtitle="'Alarm  Analysis'"></boxTitle>
			<WarningRankingList style="margin-top: 10px"></WarningRankingList>
			<DayAlarm style="margin-top: 10px"></DayAlarm>
			<RealTimeAlarmList style="margin-top: 8px"></RealTimeAlarmList>
		</div>
	</div>
</template>

<script>
import RealTimeAlarm from "./realTimeAlarm";
import RealTimeAlarmList from "./realTimeAlarmList";


import boxTitle from '../../components/boxTitle.vue'
// 实时告警
import DayAlarm from "./dayAlarm.vue";
// 设备故障
import EquipmentFailure from "./equipmentFailure.vue";
//视频监控
import videoBox from "./videoBox.vue";
// 城市预警排名
import WarningRankingList from "./warningRankingList.vue";

// import './imouplayer.js'
export default {
	data() {
		return {
			options: {}
		};
	},
	components: {
		boxTitle,
		RealTimeAlarm,
		RealTimeAlarmList,
		DayAlarm,
		EquipmentFailure,
		WarningRankingList,
		videoBox
	},
	methods: {},
	mounted() {}
}
</script>
<style lang="scss" scoped>
.surveillance {
	.operaBoxLeft {
		flex: 1;
		.alarm-flex {
			display: flex;
			height: 260px;
			margin-bottom: 45px;
			margin-top: 15px;
			> div {
				width: 50%;
				flex: 1;
			}
			> div:first-child {
				margin-right: 3px;
			}
			> div:last-child {
				margin-left: 3px;
			}
		}
	}
	.operaBoxRight {
		width: 20%;
		flex-shrink: 0;
		overflow: hidden;
		padding: 0 10px;
		box-sizing: border-box;
		> div {
			margin-top: 5px;
		}
	}
}
</style>
